import { render, staticRenderFns } from "./clsBtnV2.vue?vue&type=template&id=78a06c8e&scoped=true"
import script from "./clsBtnV2.vue?vue&type=script&lang=js"
export * from "./clsBtnV2.vue?vue&type=script&lang=js"
import style0 from "./clsBtnV2.vue?vue&type=style&index=0&id=78a06c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a06c8e",
  null
  
)

export default component.exports